import { React, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';

import HoldingCalenderInput from '../../../../../Component/MemberComponent/MemberDetail/HoldingCalenderInput';
import ReasonInput from '../../../../../Component/MemberComponent/MemberDetail/ReasonInput';
import FetchModule from '../../../../Share/Network/FetchModule';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

const MemberShipHoldingModal = (props) => {
  const { data, index, className, memberName, exitClickFn } = props;

  const history = useHistory();
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isProgress, setIsProgress] = useState(false);
  const [isViewAdminModal, setIsViewAdminModal] = useState(false);
  const [adminModalText, setAdminModalText] = useState(t('memberDetail.holdingModal.holdingAvailableDays'));
  const [compriseDate, setComprise] = useState([]);
  const [startValue, setStartValue] = useState(moment('2000-01-01'));
  const [endValue, setEndValue] = useState(moment('2000-01-01'));
  const [reasonValue, setReasonValue] = useState('');

  function holdingDateSelect(compriseDateList) {
    setComprise(compriseDateList);
  }

  function exitClick() {
    exitClickFn(className);
  }

  function saveClick() {
    if (isProgress) {
      alert(t('memberDetail.holdingModal.alertHoldingInProgress'));
      return;
    }

    let startDate = startValue.format('YYYY-MM-DDTHH:mm:ss');
    let endDate = endValue.format('YYYY-MM-DDTHH:mm:ss');

    if (endDate < startDate) {
      alert(t('memberDetail.holdingModal.alertInvalidHoldingEndDate'));
      return;
    }
    else if (data[index].availableHold !== -1 && (data[index].availableHold < (moment(endDate).diff(moment(startDate), 'days')))) {
      setAdminModalText(t('memberDetail.holdingModal.holdingAvailableDays'));
      setIsViewAdminModal(true);
      return;
    }
    else if (data[index].holdCount !== -1 && data[index].holdCount <= 0) {
      setAdminModalText(t('memberDetail.holdingModal.holdingAvailableCount'));
      setIsViewAdminModal(true);
      return;
    }

    let requestData = {
      storeId: window.sessionStorage.getItem('StoreId'),
      usageId: data[index].usageId,
      startDate: startDate,
      endDate: endDate,
      reason: reasonValue
    }

    setIsProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/create/holding/admin', 'POST', requestData);
        if (responseData.status === 200) {
          alert(t('memberDetail.holdingModal.alertHoldingSaved'));
          exitClickFn(className);
          setIsProgress(false);
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.holdingModal.alertDuplicateHolding'));
          setIsProgress(false);
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.holdingModal.alertInvalidHoldingEndDate'));
          setIsProgress(false);
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          setIsProgress(false);
          history.push('/');
        }
        else {
          alert(t('memberDetail.courseAddModal.alertDataLoadFailed'));
          setIsProgress(false);
        }
      }
    )();
  }

  // 홀딩 강제진행 클릭시 //
  function onClickAdminSave() {
    if (isProgress) {
      alert(t('memberDetail.holdingModal.alertHoldingInProgress'));
      return;
    }

    let startDate = startValue.format('YYYY-MM-DDTHH:mm:ss');
    let endDate = endValue.format('YYYY-MM-DDTHH:mm:ss');

    let requestData = {
      storeId: window.sessionStorage.getItem('StoreId'),
      usageId: data[index].usageId,
      startDate: startDate,
      endDate: endDate,
      reason: reasonValue
    }

    setIsProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('membership/create/holding/admin', 'POST', requestData);
        if (responseData.status === 200) {
          alert(t('memberDetail.holdingModal.alertHoldingSaved'));
          exitClickFn(className);
          setIsProgress(false);
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.holdingModal.alertDuplicateHolding'));
          setIsProgress(false);
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.holdingModal.alertInvalidHoldingEndDate'));
          setIsProgress(false);
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          setIsProgress(false);
          history.push('/');
        }
        else {
          alert(t('memberDetail.courseAddModal.alertDataLoadFailed'));
          setIsProgress(false);
        }
      }
    )();
  }

  // 홀딩 사용가능 일수 표시 //
  function calcAvailableHoldText() {
    if (data[index].availableHold === -1) return t('memberDetail.membershipAddModal.noLimit');
    else return (
      <span>
        <span style={{ fontFamily: 'NotoSansKR-Medium' }}>{data[index].availableHold}</span>
        <span style={{ fontFamily: 'NotoSansKR-Regular' }}>{t('memberDetail.holdingModal.dayUnit')}</span>
      </span>
    );
  }

  // 홀딩 신청가능 횟수 표시 //
  function calcHoldCountText() {
    if (data[index].holdCount === -1) return t('memberDetail.membershipAddModal.noLimit');
    else return data[index].holdCount;
  }

  return (
    <TotalModalWrapper>
      {
        isViewAdminModal ?
          <AdminModalView $isDark={isDark}>
            <AdminTotalWrapper>
              <Title>{t('memberDetail.holdingModal.holdingProceedTitle')}</Title>
              <TextWrapper>
                <UnHoverText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('memberDetail.holdingModal.holdingExceededMsg').replace('{text}', adminModalText)}</UnHoverText>
                <UnHoverText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{t('memberDetail.holdingModal.holdingProceedConfirm')}</UnHoverText>
              </TextWrapper>
              <AdminButtonWrapper>
                <ExitButton onClick={() => setIsViewAdminModal(false)}>{t('memberDetail.modalCancel')}</ExitButton>
                <AdminButton onClick={onClickAdminSave}>{t('memberDetail.modalProceed')}</AdminButton>
              </AdminButtonWrapper>
            </AdminTotalWrapper>
          </AdminModalView>
          :
          <ModalView $isDark={isDark}>
            <TotalWrapper>
              <Title>{memberName} - {t('memberDetail.holdingModal.holdingTitle')}</Title>
              <ComponentWrapper>
                <CalenderWrapper>
                  <HoldingCalenderInput
                    startValue={startValue}
                    setStartValue={setStartValue}
                    endValue={endValue}
                    setEndValue={setEndValue}
                    holdingDateSelect={holdingDateSelect} />
                </CalenderWrapper>
              </ComponentWrapper>
              <BottomComponentWrapper>
                <TotalTextBoxWrapper>
                  <TopTextBoxWrapper>
                    <TextBoxWrapper>
                      <Text>{t('memberDetail.holdingModal.availableHoldingDays')}</Text>
                      <Text>{calcAvailableHoldText()}</Text>
                    </TextBoxWrapper>
                    <TextBoxWrapper>
                      <Text>{t('memberDetail.holdingModal.holdingAvailableCountLabel')}</Text>
                      <Text>
                        {data[index].holdCount === -1
                          ? t('memberDetail.membershipAddModal.noLimit')
                          : <span style={{ fontFamily: 'NotoSansKR-Medium' }}>{data[index].holdCount}</span>
                        }
                        <span style={{ fontFamily: 'NotoSansKR-Regular' }}>{t('memberDetail.holdingModal.timesUnit')}</span>
                      </Text>
                    </TextBoxWrapper>
                  </TopTextBoxWrapper>
                  <BottomTextBoxWrapper>
                    <TextBoxWrapper>
                      <Text>{t('memberDetail.holdingModal.holdingFinalAppliedDays')}</Text>
                      <Text>
                        <span style={{ fontFamily: 'NotoSansKR-Medium' }}>{compriseDate.length}</span>
                        <span style={{ fontFamily: 'NotoSansKR-Regular' }}>{t('memberDetail.holdingModal.dayUnit')}</span>
                      </Text>
                    </TextBoxWrapper>
                    {data[index].availableHold !== -1 && compriseDate.length > data[index].availableHold &&
                      <TextBoxWrapper>
                        <WarningText>{t('memberDetail.holdingModal.holdingDaysExceeded')}</WarningText>
                      </TextBoxWrapper>
                    }
                  </BottomTextBoxWrapper>
                </TotalTextBoxWrapper>
                <RowDivision />
                <ReasonInputWrapper>
                  <ReasonInput value={reasonValue} setValue={setReasonValue} placeholder={t('memberDetail.holdingModal.reasonPlaceholder')} centerPlaceholder />
                </ReasonInputWrapper>
                <LayerWrapper>
                </LayerWrapper>
              </BottomComponentWrapper>
              <ButtonWrapper>
                <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
                <SaveButton onClick={saveClick}>{t('memberDetail.holdingModal.btnSave')}</SaveButton>
              </ButtonWrapper>
            </TotalWrapper>
          </ModalView>
      }
    </TotalModalWrapper>
  )
}

export default MemberShipHoldingModal;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  box-sizing: border-box;
  width: 900px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const AdminModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 371px;
  height: 248px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
`;

const AdminTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 84.9%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 16px 0;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const CalenderWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const BottomComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const RowDivision = styled.div`
  margin: 0 30px;

  width: 1px;
  height: 148px;

  background-color: ${props => props.theme.line};
`;

const ReasonInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  height: 148px;
`;

const TotalTextBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: flex-start;

  box-sizing: border-box;
  min-width: 286px;
  min-height: 148px;

  gap: 15px;
`;

const TopTextBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  box-sizing: border-box;
  width: 100%;

  gap: 15px;
`;

const BottomTextBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  box-sizing: border-box;
  width: 100%;

  gap: 15px;
`;

const TextBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: ${props => props.topMargin}px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;

  width: 100%;
  height: 24px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  white-space: nowrap;
`;

const WarningText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.pointRed};

  margin: 0 0 0 0;

  white-space: nowrap;
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 100%;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: ${props => props.leftMargin}px;

  padding: 0 0 0 8px;

  transition: all 0.2s ease-in-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: flex-start;
  align-items: center;
`;

const Explanation = styled.p`
  font-family: ${props => props.bold ? `NotoSansKR-Bold` : `NotoSansKR-Regular`};
  font-size: 12px;

  color: ${props => props.theme.primary};

  margin-top: 0px;
  margin-right: ${props => props.rightMargin}px;
  margin-bottom: 0px;
  margin-left: 0px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const HoldingCountWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

const HoldingCountText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const HodingInput = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 76px;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  margin: 0 8px 0 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin: 20px 0 0 0;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 27px;

  height: 40px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.subText};
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 34px;

  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const UnHoverText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const AdminButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  margin-top: 53px;

  gap: 16px;
`;

const AdminButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: #FF3131;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #DD0000;
  }
`;
